import React from "react";
import { Text, View } from "@react-pdf/renderer";
import TableGroup from "../../../exportacion_react_pdf/TableGroup";
import TextAreaLabel from "../../../exportacion_react_pdf/TextAreaLabel";

// Define el documento
const ExportPaso6 = ({ formData = {}, styles = {} }) => (
  <>
    {/* Producto Representativo */}
    <View style={styles.section}>
              <Text style={styles.title_1}>VI. Contexto</Text>
        
      <TableGroup
        questionTitle="Según el ámbito de mercado (local, municipal, departamental y nacional), enuncie para cada sector económico una o dos actividades productivas dominantes. Si no sabe la respuesta deje la casilla en blanco."
        headers={["sector", "local", "municipal", "departamental", "nacional"]}
        headerDescriptions={[
          "Sector",
          "Local",
          "Municipal",
          "Departamental",
          "Nacional",
        ]}
        data={formData?.lista_ambito_mercado_actividades_productivas || [] }
      />

      <TableGroup
        questionTitle="Según el ámbito de mercado (local, municipal, departamental y nacional) cómo califica el nivel de influencia de los diferentes sectores económicos sobre las posibilidades de crecimiento del proyecto productivo. Si la influencia es alta, marque Alto, Medio, Bajo. Si no sabe o no desea responder, marque NS/NR."
        headers={["sector", "local", "municipal", "departamental", "nacional"]}
        headerDescriptions={[
          "Sector",
          "Local",
          "Municipal",
          "Departamental",
          "Nacional",
        ]}
        data={formData?.lista_nivel_influencia_diferentes_sectores || []}
      />

      <TableGroup
        questionTitle="Según el ámbito de mercado  (local, municipal, departamental y nacional) y para cada sector califique las expectativas de crecimiento para las ventas o servicios finales ofrecidos por el proyecto productivo.  Si la expectativa es alta, moderada o baja. Si no sabe o no desea responder, marque NS/NR."
        headers={["sector", "local", "municipal", "departamental", "nacional"]}
        headerDescriptions={[
          "Sector",
          "Local",
          "Municipal",
          "Departamental",
          "Nacional",
        ]}
        data={formData?.lista_expectativas_crecimiento_sector || []}
      />

      <TableGroup
        questionTitle="Según el ámbito de mercado (local, municipal, departamental y nacional)  determine el nivel de compras y/o adquisición de insumos que hace el proyecto productivo a los diferentes sectores económicos.  Si el nivel es alto, moderado o bajo. Si no sabe o no desea responder, marque NS/NR."
        headers={["sector", "local", "municipal", "departamental", "nacional"]}
        headerDescriptions={[
          "Sector",
          "Local",
          "Municipal",
          "Departamental",
          "Nacional",
        ]}
        data={formData?.lista_compras_adquisicion_insumos_sector || []}
      />

      <TextAreaLabel
        label={
          "Teniendo en cuenta las preguntas anteriores la persona en reincorporación y el asesor identifiquen oportunidades del sector económico del proyecto productivo en lo Local, Municipal, Departamental y Nacional (si aplica)"
        }
        value={formData?.oportunidades_del_sector_economico || ""}
      ></TextAreaLabel>

      <TextAreaLabel
        label={
          "Teniendo en cuenta las preguntas anteriores la persona en reincorporación y el asesor identifiquen amenazas del sector económico del proyecto productivo en lo Local, Municipal, Departamental y Nacional (si aplica)"
        }
        value={formData?.amenazas_del_sector_economico || ""}
      ></TextAreaLabel>
    </View>
  </>
);

export default ExportPaso6;
